<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <v-select
                  :items="levelOptions"
                  v-model="academicLevel"
                  label="Cấp"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <AutocompleteSubjectGroup
                  v-model="subjectGroup"
                  item-text="title"
                  item-value="id"
                  label="Tổ"
                  dense
                  outlined
                  auto-select-first
                  :hideDetails="true"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <div class="d-flex justify-end">
                  <v-btn
                    class="search-button"
                    :class="{ 'px-2': windowWidth < 1100 }"
                    @click="onFilterChanged"
                    outlined
                    :disabled="!this.academicLevel || !this.subjectGroup"
                  >
                    Tìm kiếm
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteSubjectGroup from '../input/AutocompleteSubjectGroup.vue'

export default {
  components: {
    AutocompleteSubjectGroup
  },
  data: () => ({
    show: false,
    status: 'active',
    title: '',
    code: '',
    subjectGroup: '',
    academicLevel: '',
    windowWidth: window.innerWidth,
    levelOptions: [
      { name: 'Cấp 2', value: 'secondary' },
      { name: 'Cấp 3', value: 'high' }
    ]
  }),
  props: {
    defaultFilters: Object
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('grade', ['query'])
  },
  created() {},
  methods: {
    ...mapActions({}),
    onFilterChanged() {
      const query = {
        subjectGroup: this.subjectGroup,
        academicLevel: this.academicLevel
      }
      this.$emit('onFilterChanged', query)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
